import React from 'react'

const ModernBankingHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5  py-28 bg-bgDefault text-white ">
            <div className='container xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-12 gap-8'>
                    <div className='col-span-12 md:col-span-6'>
                        <h2 className="text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 ">
                            Modernizing Banking Infrastructure
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Java
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Microservices
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                AWS
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Kubernetes
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              We partnered with a leading APAC fintech company that has transformed 150+ banks worldwide to architect
                              their next-generation cloud-native banking platform. Our microservices-based solution successfully handles
                              2 million users on peak days and 500,000+ daily active users with API response times under 3 seconds,
                              deployed on AWS using Docker and Kubernetes with Horizontal Pod Autoscaling. The platform revolutionized
                              customer banking experiences through personalized services, seamless third-party integrations, and
                              OAuth 2.0 security, establishing new standards for modern digital banking infrastructure.
                            </p>

                    </div>
                    <div className='col-span-12 md:col-span-6'>
                      <img src='/case_studies/title-banner/banking-app-title-banner.png' alt='Modern Banking Infrastructure' className='w-full h-auto'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ModernBankingHero
